import { render, staticRenderFns } from "./ResellersMap.vue?vue&type=template&id=686070a8"
import script from "./ResellersMap.vue?vue&type=script&lang=js"
export * from "./ResellersMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports